import { Routes } from '@angular/router';
import { AuthGuardService } from '../guards/auth-guard.service';
import { PromoCreateComponent } from './promo-create/promo-create.component';
import { PromoComponent } from './promo.component';
import {PromoEditComponent} from "./promo-edit/promo-edit.component";

export const promosRoutes: Routes = [
  {
    path: 'promo',
    canActivate: [ AuthGuardService ],
    children: [
      {
        path: 'create',
        component: PromoCreateComponent,
      },
      {
        path: ':promoId/edit',
        component: PromoEditComponent,
      },
      {
        path: '',
        component: PromoComponent
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/app/promos/promo.routes.ts